import script from "./createRedEnvelopeRain.vue?vue&type=script&setup=true&lang=ts"
export * from "./createRedEnvelopeRain.vue?vue&type=script&setup=true&lang=ts"

import "./createRedEnvelopeRain.vue?vue&type=style&index=0&id=6737976c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6737976c"]])

export default __exports__